export default {"src":"/_next/static/media/tailored-pricing.10c9126e.svg","height":53,"width":43};